
import { ActionList, CustomAction } from "@/models/MapPois/Quest/Actions";
import { Component, Vue, Prop } from "vue-property-decorator";
import AlertBoxEditable from "../../../Base/AlertBoxEditable.vue";

@Component({
  components: { AlertBoxEditable },
})
class ActionTimerEdit extends Vue {
  @Prop({ default: false }) readonly contentData!: ActionList;
  @Prop({ default: "" }) readonly title!: string;
  @Prop({ default: false }) readonly showTextBox!: boolean;
  @Prop({ default: "" }) readonly placeholder!: string;
  @Prop({ default: true }) readonly isEditingLocked!: boolean;
  jsonValue = "";
  errorMessage = "";
  customAction: CustomAction = {
    parentID: "",
    json: "",
    status: "active",
  };
  isValid = false;
  successMessage = "";

  created(): void {
    if (this.contentData?.customAction !== undefined) {
      this.jsonValue = this.contentData.customAction.json;
    }
  }
  cancel(): void {
    this.$emit("cancel");
  }
  textBoxChange(): void {
    this.errorMessage = "";
    this.successMessage = "";
    this.isValid = false;
  }
  update(): void {
    this.errorMessage = "";
    this.isValidJson();
    if (this.isValid || this.jsonValue.trim() == "") {
      this.customAction.json = this.jsonValue;

      if (this.customAction.json == "") {
        this.customAction.status = "inactive";
        this.$emit("deleteAction");
      } else {
        this.customAction.status = "active";
        this.$emit("update", this.customAction);
      }
    } else {
      this.errorMessage = "Please make sure it is valid JSON.";
    }
  }
  openClearDialog(): void {
    this.$bvModal.show("team-modal-alert-edit");
  }

  alertOk(): void {
    this.customAction = {
      parentID: "",
      json: "",
      status: "active",
    };
    this.$emit("deleteAction");
  }

  isValidJson(): void {
    if (this.jsonValue.trim() == "") {
      this.isValid = true;
    } else {
      try {
        JSON.parse(this.jsonValue);
        this.successMessage = "JSON is valid!";
        this.errorMessage = "";
        this.isValid = true;
      } catch (e) {
        this.errorMessage = `Invalid JSON: ${e.message}`;
        this.successMessage = "";
        this.isValid = false;
      }
    }
  }
}

export default ActionTimerEdit;
